// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__24bSA","inputDescription":"styles_inputDescription__370aV"};